module.exports = __webpack_public_path__ + "img/ts_2016.758b176d.jpg";